import { Col, Form, Row } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { saveShipmentProductInProgress } from '../../../../redux/shipment/ShipmentActions';
import { valueToNumber, valueToString } from '../../../../utilz';
import { routeFileSelector } from '../../../../utilz/i18n';
import FormInput from '../../../components/Inputs/FormInput';
import FormTextArea from '../../../components/Inputs/FormTextArea';
import ClaimsCommodityCodeSelector from '../../../components/Selectors/ClaimsCommodityCodeSelector';
import ClaimsLidLabelSelector from '../../../components/Selectors/ClaimsLidLabelSelector';
import ClaimsRegularReleaseSelector from '../../../components/Selectors/ClaimsRegularReleaseSelector';
import ProductUnitUomSelector from '../../../components/Selectors/ProductUnitUomSelector';

// TODO: move to claims folder
const AddProductFullForm = ({ formInstance = false, handleSuccess }) => {
  const dispatch = useDispatch();
  const { selectedCompany, user } = useSelector((state) => state.auth);
  let [form] = Form.useForm();
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  if (formInstance) {
    form = formInstance;
  }

  const handleSubmit = (data) => {
    const payload = {
      ...data,
      customerKey: selectedCompany?.companyId,
      createdBy: user?.data?.id,
      callback: handleCallback,
      productUnitMeasure: valueToString(data?.productUnitMeasure),
      fullRelFlag: valueToString(data?.fullRelFlag),
      releaseValue: valueToNumber(data.releaseValue),
      claimantValue: valueToNumber(data.claimantValue),
      productWeight: valueToNumber(data.productWeight),
      nmfcClassNumber: valueToString(data?.nmfcClassNumber),
      palletWeight: valueToNumber(data.palletWeight),
      palletVolume: valueToNumber(data.palletVolume),
      commodityCodeKey: valueToNumber(data.commodityCodeKey),
      lidLabelKey: valueToNumber(data.lidLabelKey),
      optimizationIdentifier: valueToString(data?.optimizationIdentifier),
      shipRecKey: valueToNumber(data.shipRecKey),
      hazmatUnNumber: valueToString(data?.hazmatUnNumber),
    };
    dispatch(saveShipmentProductInProgress(payload));
  };

  const handleCallback = (data) => {
    form.resetFields();
    if (handleSuccess) {
      handleSuccess(data);
    }
  };

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      initialValues={{
        productUnitMeasure: undefined,
        fullRelFlag: ' ',
        releaseValue: undefined,
        claimantValue: undefined,
        productWeight: undefined,
        nmfcClassNumber: undefined,
        palletWeight: undefined,
        palletVolume: undefined,
        commodityCodeKey: undefined,
        lidLabelKey: undefined,
        optimizationIdentifier: undefined,
        shipRecKey: undefined,
        hazmatUnNumber: undefined,
      }}
    >
      <Row gutter={30}>
        <Col md={8}>
          <FormInput
            name="productCode"
            label={t('translation:default.fields.productCode.label')}
            editMode
            rules={[
              {
                required: true,
                message: t('translation:default.fields.productCode.message'),
              },
            ]}
            maxLength={25}
            margin="mb-10"
          />
          <FormTextArea
            name="productDesc"
            label={t('translation:default.fields.productDesc.label')}
            editMode
            rows={3}
            margin="mb-10"
            rules={[
              {
                required: true,
                message: 'Please enter Product Description',
              },
            ]}
            maxLength={150}
          />
          <ProductUnitUomSelector
            margin="mb-10"
            label="Unit Of Measure"
            placeholder="Select A Unit Of Measure"
            name="productUnitMeasure"
            editMode
          />
          <ClaimsRegularReleaseSelector
            margin="mb-10"
            label="Full/Release Value"
            placeholder="Select A Full/Release Value"
            name="fullRelFlag"
            editMode
          />
          <FormInput
            margin="m-0"
            label="Release"
            placeholder="Select A Release"
            name="releaseValue"
            editMode
            inputType="number"
          />
        </Col>
        <Col md={8}>
          <FormInput
            margin="mb-10"
            label="Claimant Value"
            placeholder="Enter Claimant Value"
            name="claimantValue"
            editMode
            inputType="number"
          />
          <FormInput
            margin="mb-10"
            label="Chargeable Weight"
            placeholder="Enter Chargeable Weight"
            name="productWeight"
            editMode
            inputType="number"
          />
          <FormInput
            margin="mb-10"
            label="NMFC Class"
            placeholder="Enter NMFC Class"
            name="nmfcClassNumber"
            editMode
            maxLength={25}
          />
          <ClaimsCommodityCodeSelector margin="mb-10" name="commodityCodeKey" editMode />
          <FormInput
            margin="m-0"
            label="Pallet Weight"
            placeholder="Enter Pallet Weight"
            name="palletWeight"
            editMode
            inputType="number"
          />
        </Col>
        <Col md={8}>
          <FormInput
            margin="mb-10"
            label="Pallet Volumn"
            placeholder="Enter Pallet Volumn"
            name="palletVolume"
            editMode
            inputType="number"
          />
          <ClaimsLidLabelSelector margin="mb-10" name="lidLabelKey" editMode />
          <FormInput
            margin="mb-10"
            label="Optimization ID"
            placeholder="Enter Optimization ID"
            name="optimizationIdentifier"
            editMode
          />
          <FormInput
            margin="mb-10"
            label="Ship/Rec Key"
            placeholder="Enter Ship/Rec Key"
            name="shipRecKey"
            editMode
            inputType="number"
          />
          <FormInput
            margin="m-0"
            label="HAZMAT UN Number"
            placeholder="Enter HAZMAT UN Number"
            name="hazmatUnNumber"
            editMode
            maxLength={10}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default AddProductFullForm;
